export enum VALID_ENV_KEYS {
  AIDON_API_KEY = "AIDON_API_KEY",
  ANTHROPIC_API_KEY = "ANTHROPIC_API_KEY",
  AZURE_OPENAI_API_KEY = "AZURE_OPENAI_API_KEY",
  GOOGLE_GEMINI_API_KEY = "GOOGLE_GEMINI_API_KEY",
  GROQ_API_KEY = "GROQ_API_KEY",
  MISTRAL_API_KEY = "MISTRAL_API_KEY",
  OPENAI_API_KEY = "OPENAI_API_KEY",
	OPENAI_EMBEDDING_API_KEY = "OPENAI_EMBEDDING_API_KEY",
  OPENROUTER_API_KEY = "OPENROUTER_API_KEY",
  PERPLEXITY_API_KEY = "PERPLEXITY_API_KEY",
  XAI_API_KEY = "XAI_API_KEY",

  OPENAI_ORGANIZATION_ID = "OPENAI_ORGANIZATION_ID",

  AZURE_OPENAI_ENDPOINT = "AZURE_OPENAI_ENDPOINT",
  AZURE_EMBEDDINGS_NAME = "AZURE_EMBEDDINGS_NAME"
}

export const keyMap: Record<string, VALID_ENV_KEYS> = {
	aidon: VALID_ENV_KEYS.AIDON_API_KEY,
	anthropic: VALID_ENV_KEYS.ANTHROPIC_API_KEY,
	azure: VALID_ENV_KEYS.AZURE_OPENAI_API_KEY,
	google: VALID_ENV_KEYS.GOOGLE_GEMINI_API_KEY,
	groq: VALID_ENV_KEYS.GROQ_API_KEY,
	mistral: VALID_ENV_KEYS.MISTRAL_API_KEY,
	openai: VALID_ENV_KEYS.OPENAI_API_KEY,
	openrouter: VALID_ENV_KEYS.OPENROUTER_API_KEY,
	perplexity: VALID_ENV_KEYS.PERPLEXITY_API_KEY,
	xai: VALID_ENV_KEYS.XAI_API_KEY,

	openai_organization_id: VALID_ENV_KEYS.OPENAI_ORGANIZATION_ID,

	azure_openai_endpoint: VALID_ENV_KEYS.AZURE_OPENAI_ENDPOINT,
	azure_embeddings_name: VALID_ENV_KEYS.AZURE_EMBEDDINGS_NAME
}

export const profileKeys = {
	[VALID_ENV_KEYS.ANTHROPIC_API_KEY]: "anthropic_api_key",
	[VALID_ENV_KEYS.AZURE_OPENAI_API_KEY]: "azure_openai_api_key",
	[VALID_ENV_KEYS.GOOGLE_GEMINI_API_KEY]: "google_gemini_api_key",
	[VALID_ENV_KEYS.GROQ_API_KEY]: "groq_api_key",
	[VALID_ENV_KEYS.MISTRAL_API_KEY]: "mistral_api_key",
	[VALID_ENV_KEYS.OPENAI_API_KEY]: "openai_api_key",
	[VALID_ENV_KEYS.OPENROUTER_API_KEY]: "openrouter_api_key",
	[VALID_ENV_KEYS.PERPLEXITY_API_KEY]: "perplexity_api_key",
	[VALID_ENV_KEYS.XAI_API_KEY]: "xai_api_key",

	[VALID_ENV_KEYS.OPENAI_ORGANIZATION_ID]: "openai_organization_id",

	[VALID_ENV_KEYS.AZURE_OPENAI_ENDPOINT]: "azure_openai_endpoint",
	[VALID_ENV_KEYS.AZURE_EMBEDDINGS_NAME]: "azure_openai_embeddings_id"
}
